'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReactFireVis = createReactFireVis;

var _d = require('../../src/main/resources/static/vendor/scripts/firevis-1.0.1/dependencies/d3-4.2.6/d3.min');

var d3 = _interopRequireWildcard(_d);

require('airbnb-js-shims');

require('react-dates/initialize');

require('react-dates/lib/css/_datepicker.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

window.d3 = d3;

function createReactFireVis(id, type, data, chartConfig) {
  var ReactFireVis = (0, _react.lazy)(function () {
    return import( /* webpackChunkName: "firevis" */ // eslint-disable-line no-inline-comments
    "../../app/implementation/firevis");
  });
  var LazyReactFireVis = function LazyReactFireVis() {
    return _react2.default.createElement(
      _react.Suspense,
      { fallback: _react2.default.createElement(
          'div',
          null,
          'Loading...'
        ) },
      _react2.default.createElement(ReactFireVis, { id: id, type: type, data: data, chartConfig: chartConfig })
    );
  };
  LazyReactFireVis.displayName = 'LazyReactFireVis';
  return LazyReactFireVis;
}